import React from "react";
import { Link } from "react-router-dom";

import {
  usePreferences,
} from "../context/PreferencesContext";

import {
  getAvaaioAuthCopy,
  interpolateAuthCopy,
} from "../utils/avaaioAuthCopy";

export default function GlobalFooter({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { preferences } = usePreferences();

  const copy = getAvaaioAuthCopy(
    preferences.language,
  );

  const links = [
    {
      path: "/privacy-policy",
      label: copy.common.privacy,
    },
    {
      path: "/terms-and-conditions",
      label: copy.common.terms,
    },
    {
      path: "/ai-disclaimer",
      label: copy.common.aiDisclaimer,
    },
    {
      path: "/credits",
      label: copy.common.credits,
    },
    {
      path: "/support",
      label: copy.common.support,
    },
  ];

  return (
    <footer
      className={`avaaio-global-footer${
        compact
          ? " avaaio-global-footer--compact"
          : ""
      }`}
    >
      <div className="avaaio-global-footer__identity">
        {copy.common.powered}
      </div>

      <div className="avaaio-global-footer__copyright">
        {interpolateAuthCopy(
          copy.common.copyright,
          {
            year: new Date().getFullYear(),
          },
        )}
      </div>

      <nav
        className="avaaio-global-footer__links"
        aria-label="AVAAIO legal and support links"
      >
        {links.map((link, index) => (
          <React.Fragment key={link.path}>
            <Link to={link.path}>
              {link.label}
            </Link>

            {index < links.length - 1 ? (
              <span
                aria-hidden="true"
                className="avaaio-global-footer__separator"
              >
                •
              </span>
            ) : null}
          </React.Fragment>
        ))}
      </nav>
    </footer>
  );
}
